import angular from "angular";
import { Ajax, Configs, OAuthMessage } from "@salaxy/core";
import { SessionService } from "../../services";

/**
 * Controller for Omapalkka integration.
 */
export class OmapalkkaController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1", "SessionService", "$sce"];

  private _url = null;
  private _urlInProgress = false;

  /**
   * Creates a new ContactInfoController
   * @ignore
   */
  constructor(private ajax: Ajax, private sessionService: SessionService, private $sce: angular.ISCEService) {
    //
  }

  /**
   * Implement IController
   */
  public $onInit = () => {
    // initialization
  };

  /** Gets the URL to the Omapalkka server with Google Firebase token. */
  public get url() {
    if (this.sessionService.isAuthenticated) {
      if (!this._url) {
        if (!this._urlInProgress) {
          this._urlInProgress = true;
          this.ajax.getJSON(`${Configs.current.getOmapalkkaApiServer()}/api/security/token`).then( (msg: OAuthMessage) => {
            const embeddedUrl = `${Configs.current.getOmapalkkaServer()}/embedded.html#fb-token=${msg?.access_token}`;
            // const embeddedUrl = `http://localhost:3000/embedded.html#fb-token=${msg?.access_token}`;
            this._url = this.$sce.trustAsResourceUrl(embeddedUrl);
          });
        }
      }
    }
    return this._url;
  }
}
